import {
  Button,
  ButtonCallNotes,
  ButtonGoBack,
  SelectableItem,
} from '../../Shared';

const DO_NOT_CALL_VARIANTS = [
  { label: 'Wrong Contact', value: 'wrongContact' },
  { label: 'Wrong Number', value: 'wrongNumber' },
  { label: 'Bad Number', value: 'badNumber' },
  { label: 'Company not in business', value: 'companyNotInBusiness' },
  { label: 'No Longer with Company', value: 'noLongerWithCompany' },
  { label: 'Retired', value: 'retired' },
  { label: 'Remove from List', value: 'removeFromList' },
  { label: 'Unsuitable company', value: 'unsuitableCompany' },
  { label: 'Current customer', value: 'currentCustomer' },
];

export const CommonDiscard = ({
  handleFinishCall,
  dialOutcomeDetail,
  setDialOutcomeDetail,
  handleOpen3,
  formCallNotes,
  resetPitchState,
  isDialOutcomesLoading,
}) => {
  return (
    <>
      <div className="h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
        <p className="text-brand-900 text-center font-semibold text-[18px]/[24px]">
          Why are you marking the prospect as Do Not Call?
        </p>
        <div className="cursor-pointer mt-6 flex flex-wrap items-center justify-center gap-3">
          {DO_NOT_CALL_VARIANTS.map(({ label, value }) => (
            <SelectableItem
              key={value}
              label={label}
              selected={value === dialOutcomeDetail}
              onClick={() => {
                setDialOutcomeDetail(value);
              }}
              variant="secondary"
            />
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
        <ButtonGoBack
          onClick={() => {
            setDialOutcomeDetail('');
            resetPitchState(true);
          }}
          disabled={isDialOutcomesLoading}
        />
        <Button
          title="Finish"
          onClick={handleFinishCall}
          disabled={!dialOutcomeDetail || isDialOutcomesLoading}
        />
        <ButtonCallNotes
          onClick={handleOpen3}
          hasBg={formCallNotes && formCallNotes !== 'null'}
          disabled={isDialOutcomesLoading}
        />
      </div>
    </>
  );
};
